export const actionTypes = {
  TYPE_REQUEST: "TYPE_REQUEST",
  TYPE_REQUEST_SUCCESS: "TYPE_REQUEST_SUCCESS",
  TYPE_REQUEST_FAILURE: "TYPE_REQUEST_FAILURE",
  FIELD_REQUEST: "FIELD_REQUEST",
  FIELD_REQUEST_SUCCESS: "FIELD_REQUEST_SUCCESS",
  FIELD_REQUEST_FAILURE: "FIELD_REQUEST_FAILURE",
  SEND_REQUEST: "SEND_REQUEST",
  SEND_REQUEST_SUCCESS: "SEND_REQUEST_SUCCESS",
  SEND_REQUEST_FAILURE: "SEND_REQUEST_FAILURE",
  SEND_NEW_API_REQUEST: "SEND_NEW_API_REQUEST",
  SEND_NEW_API_REQUEST_SUCCESS: "SEND_NEW_API_REQUEST_SUCCESS",
  SEND_NEW_API_REQUEST_FAILURE: "SEND_NEW_API_REQUEST_FAILURE",
  GET_SERVICE_RERQUEST_BAO: "GET_SERVICE_RERQUEST_BAO",
  GET_SERVICE_RERQUEST_BAO_SUCCESS: "GET_SERVICE_RERQUEST_BAO_SUCCESS",
  GET_SERVICE_RERQUEST_BAO_FAILURE: "GET_SERVICE_RERQUEST_BAO_FAILURE",
  GET_SERVICE_RERQUEST_APPLICATIONS: "GET_SERVICE_RERQUEST_APPLICATIONS",
  GET_SERVICE_RERQUEST_APPLICATIONS_SUCCESS:
    "GET_SERVICE_RERQUEST_APPLICATIONS_SUCCESS",
  GET_SERVICE_RERQUEST_APPLICATIONS_FAILURE:
    "GET_SERVICE_RERQUEST_APPLICATIONS_FAILURE",
};

export const typeRequest = () => ({
  type: actionTypes.TYPE_REQUEST,
});

export const typeRequestSuccess = (payload: any) => ({
  type: actionTypes.TYPE_REQUEST_SUCCESS,
  payload,
});

export const typeRequestFailure = (error: Error) => ({
  type: actionTypes.TYPE_REQUEST_FAILURE,
  error,
});

export const getServiceRequestBAO = () => ({
  type: actionTypes.GET_SERVICE_RERQUEST_BAO,
});

export const getServiceRequestBAOSuccess = (payload: any) => ({
  type: actionTypes.GET_SERVICE_RERQUEST_BAO_SUCCESS,
  payload,
});

export const getServiceRequestBAOFailure = (error: Error) => ({
  type: actionTypes.GET_SERVICE_RERQUEST_BAO_FAILURE,
  error,
});

export const getServiceRequestApplications = () => ({
  type: actionTypes.GET_SERVICE_RERQUEST_APPLICATIONS,
});

export const getServiceRequestApplicationsSuccess = (payload: any) => ({
  type: actionTypes.GET_SERVICE_RERQUEST_APPLICATIONS_SUCCESS,
  payload,
});

export const getServiceRequestApplicationsFailure = (error: Error) => ({
  type: actionTypes.GET_SERVICE_RERQUEST_APPLICATIONS_FAILURE,
  error,
});

export const fieldRequest = (idServiceRequest: number) => ({
  type: actionTypes.FIELD_REQUEST,
  idServiceRequest,
});

export const fieldRequestSuccess = (payload: any) => ({
  type: actionTypes.FIELD_REQUEST_SUCCESS,
  payload,
});

export const fieldRequestFailure = (error: Error) => ({
  type: actionTypes.FIELD_REQUEST_FAILURE,
  error,
});

export const sendRequest = (obj: FormData) => ({
  type: actionTypes.SEND_REQUEST,
  obj,
});

export const sendRequestSuccess = () => ({
  type: actionTypes.SEND_REQUEST_SUCCESS,
});

export const sendRequestFailure = (error: Error) => ({
  type: actionTypes.SEND_REQUEST_FAILURE,
  error,
});

export const sendNewApiRequest = (obj: FormData) => ({
  type: actionTypes.SEND_NEW_API_REQUEST,
  obj,
});

export const sendNewApiRequestSuccess = () => ({
  type: actionTypes.SEND_NEW_API_REQUEST_SUCCESS,
});

export const sendNewApiRequestFailure = (error: Error) => ({
  type: actionTypes.SEND_NEW_API_REQUEST_FAILURE,
  error,
});
